import axios from "axios";
import { config } from "@/config/env";
// import { deflate } from "pako";

const API_URL = `https://api.${config.baseUrl}`;
const MENU_URL = `https://menu.${config.baseUrl}`;

export type GetTokenFunction = () => Promise<string | null>;

export const createApiClient = (getToken: GetTokenFunction) => {
  const apiClient = axios.create({
    baseURL: API_URL,
  });

  apiClient.interceptors.request.use(async (config) => {
    // add auth token
    try {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error("Error getting auth token:", error);
    }

    // compress body
    if (config.data && typeof config.data === "object") {
      // config.headers["Content-Encoding"] = "deflate";
      // config.headers["Content-Type"] = "application/json";
      // config.data = deflate(JSON.stringify(config.data));
    }

    return config;
  });

  return apiClient;
};

export const createMenuClient = () => {
  const menuClient = axios.create({
    baseURL: MENU_URL,
  });

  // compress body
  menuClient.interceptors.request.use(async (config) => {
    if (config.data && typeof config.data === "object") {
      // config.headers["Content-Encoding"] = "deflate";
      // config.headers["Content-Type"] = "application/json";
      // config.data = deflate(JSON.stringify(config.data));
    }
    return config;
  });

  return menuClient;
};

interface ApiErrorResponse {
  message: string;
}

export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError<ApiErrorResponse>(error)) {
    return error.response?.data?.message || error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
};
